// components/Header.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

const Header = () => {
  const location = useLocation();
  
  const mainMenuItems = [
    { name: 'Blog', path: '/blog' },
    { name: 'Prodaja kompanije', path: '/ksb' },
    { name: 'Kontakt', path: '/kontakt' }
  ];

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        {/* Centrirana slika */}
        <div className={styles.logoWrapper}>
          <Link to="/" className={styles.logoLink}>
            <img src="/logo.png" alt="Jović Advisory" className={styles.logo} />
          </Link>
        </div>
        
        {/* Centrirani meni ispod slike */}
        <nav className={styles.mainNav}>
          <ul className={styles.navList}>
            {mainMenuItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path}
                  className={`${styles.navLink} ${
                    location.pathname.startsWith(item.path) ? styles.active : ''
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;